<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2> 
        </div>
        <div class="col-md-11 d-flex justify-content-end">
            <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoMoneda">
                <i class="fa-solid fa-plus"></i>
            </b-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listTipoMoneda.length > 0">
            <div class="col-md-5">
                <b-table
                    :items="listTipoMoneda"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    @row-clicked="(item) => editTipoMoneda(item.id)"
                >
                    <template #cell(moneda)="data">
                        <div class="text-right">{{ data.item?.moneda }}</div>
                    </template>
                    <template #cell(descripcion)="data">
                        <div class="text-left">{{ data.item?.descripcion }}</div>
                    </template>
                    <template #cell(acronimo)="data">
                        <div class="text-left">{{ data.item?.acronimo }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 align-items-center mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                            :items="currentPage"
                            :total-rows="listTipoMoneda.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            :items="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modCrearTipoMoneda="showCrearTipMoneda" @cierraModal="closeModal"></Crear>
        <Editar :modEditarTipoMoneda="showEditarTipMoneda" :infoTipoMoneda="dataTipMoneda" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda'; 
import Crear from './Crear.vue'; 
import Editar from './Editar.vue'; 

export default {
    name : 'Tipo moneda',
    components: {Crear,Editar},
    data : () => ({
        listTipoMoneda : [],
        showCrearTipMoneda : false,
        showEditarTipMoneda : false,
        dataTipMoneda : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'moneda', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'acronimo', label: 'Acrónimo', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Tipo moneda',
                    noRow : "No hay registros",
                    codMoneda : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo'
                }
            }else{
                return {
                    title : 'Currency type',
                    noRow : "There are not records",
                    codMoneda : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym'
                }
            }
        }
    },
    methods:{
        createTipoMoneda(){
            this.showCrearTipMoneda = true 
        },
        editTipoMoneda(id){
            TipoMoneda.getTipoMonedaById(id) 
            .then((res) => { 
                this.dataTipMoneda = res.data.tipoMoneda 
                this.showEditarTipMoneda = true 
            })
            .catch((err) => console.log(err)) 
        },
        closeModal(val){
            this.showCrearTipMoneda = val 
            this.showEditarTipMoneda = val 
        }
    },
    mounted(){
        TipoMoneda.getAllTipoMoneda() 
        .then((res) => { 
            // console.log(res.data.listTipoMoneda); 
            const data = res.data.listTipoMoneda 
            this.listTipoMoneda = Array.isArray(data) ? data : (data && typeof data === 'object' ? Object.values(data) : []) 
        })
        .catch((error) => console.log(error)) 
    }
}
</script>

<style>

</style>
